import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';

import { IpResolverService } from '@commons/services/ip-resolver.service';

import { ResetPasswordService } from '@account/services/resetPassword.service';
import { NavigationService } from '@home/services';
import { Parameter } from '@model/pay/parameter';
import { ResetPasswordResponse } from '@model/resetPasswordResponse';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css'],
})
export class RecoverPasswordComponent implements OnInit {
  @Output('outEmail') outEmail = new EventEmitter();

  private readonly resetPasswordService: ResetPasswordService;
  private readonly recaptchaV3Service: ReCaptchaV3Service;
  private readonly ipService: IpResolverService;
  private readonly formBuilder: FormBuilder;
  private readonly navigationService: NavigationService;

  public ipAddress: string;
  public form: FormGroup;
  public response: ResetPasswordResponse;
  public statusError: boolean = false;
  public showLoader = false;
  public messageError: string;
  public onlyNumbersRegExp: RegExp;

  constructor(private injector: Injector) {
    this.resetPasswordService = this.injector.get(ResetPasswordService);
    this.recaptchaV3Service = this.injector.get(ReCaptchaV3Service);
    this.ipService = this.injector.get(IpResolverService);
    this.formBuilder = this.injector.get(FormBuilder);
    this.navigationService = this.injector.get(NavigationService);

    this.onlyNumbersRegExp = /^\d+$/;
  }

  ngOnInit(): void {
    this.getIpAddress();
    this.initForm();
  }

  private initForm() {
    this.form = this.formBuilder.group({
      document: new FormControl('', [
        Validators.required,
        Validators.pattern(this.onlyNumbersRegExp),
        Validators.maxLength(13),
        Validators.minLength(4),
      ]),
    });
  }

  private getIpAddress() {
    this.ipService.getIPAddress().subscribe(
      (data: any) => {
        this.ipAddress = data.response;
      },
      (err) => console.error('No se pudo capturar la IP: ' + err)
    );
  }

  public changePassword() {
    if (this.form.valid) {
      this.recaptchaV3Service.execute('recover_password').subscribe((token) => {
        this.showLoader = true;
        this.resetPasswordService.postMailEncrypt(Parameter.RAPIPLAZO, this.form.value.document, token).subscribe(
          (res) => {
            this.response = res;

            if (this.response.status) {
              this.outEmail.emit(this.response.email);
            } else {
              this.statusError = true;
              this.messageError = this.response.message;
            }

            this.showLoader = false;
          },
          (err) => {
            this.messageError = this.response.message;
            this.statusError = true;
            this.showLoader = false;
          }
        );
      });
    } else {
      this.form.markAllAsTouched();
    }
  }

  onlyNumbers(event: any) {
    return event.charCode == 8 || event.charCode == 0 ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  public redirectToLogin() {
    this.navigationService.redirectToLogin();
  }
}
